const finiteNumber = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;

export const getVisualViewportBounds = (view = window) => {
  const viewport = view.visualViewport;
  const left = finiteNumber(viewport?.offsetLeft, 0);
  const top = finiteNumber(viewport?.offsetTop, 0);
  const width = Math.max(0, finiteNumber(viewport?.width, view.innerWidth));
  const height = Math.max(0, finiteNumber(viewport?.height, view.innerHeight));
  return { left, top, width, height, right: left + width, bottom: top + height };
};

const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), Math.max(minimum, maximum));

export const placeFloatingPanel = ({
  anchor,
  width,
  height,
  align = "start",
  gap = 6,
  margin = 10,
  viewport = getVisualViewportBounds(),
}) => {
  const availableWidth = Math.max(1, viewport.width - (margin * 2));
  const panelWidth = Math.min(Math.max(1, width), availableWidth);
  const availableBelow = Math.max(0, viewport.bottom - anchor.bottom - gap - margin);
  const availableAbove = Math.max(0, anchor.top - viewport.top - gap - margin);
  const openAbove = availableBelow < Math.min(height, 180) && availableAbove > availableBelow;
  const panelHeight = Math.min(height, openAbove ? availableAbove : availableBelow);
  const minimumTop = viewport.top + margin;
  const maximumTop = viewport.bottom - margin - panelHeight;
  const naturalTop = openAbove ? anchor.top - gap - panelHeight : anchor.bottom + gap;
  const naturalLeft = align === "end" ? anchor.right - panelWidth : anchor.left;

  return {
    top: clamp(naturalTop, minimumTop, maximumTop),
    left: clamp(naturalLeft, viewport.left + margin, viewport.right - margin - panelWidth),
    width: panelWidth,
    maxHeight: panelHeight,
    openAbove,
  };
};
